import { trackEvent, eventNameConstants } from 'dibs-tracking';

export type SellerTimeAwayTrackingTrigger =
    | 'mc siderail'
    | 'mc header'
    | 'seller info'
    | 'message drawer'
    | 'ask a seller modal';

export const trackSellerTimeAwayDisplayed = (trigger: SellerTimeAwayTrackingTrigger): void => {
    trackEvent({
        eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
        interaction_type: 'seller time away',
        step_interaction_name: 'displayed',
        trigger,
    });
};
